import { render, staticRenderFns } from "./DomainRoleSelector.vue?vue&type=template&id=5de2107c&lang=pug"
import script from "./DomainRoleSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./DomainRoleSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports